
export enum LoginState {
  notKnown,
  loggedIn,
  notLoggedIn
}
